import Vue from "vue";
import VueRouter, { RouteConfig, NavigationGuard, Route, RawLocation } from "vue-router";
import store from "@/store/store";
import dirtyness from "@/utilities/Dirtyness";

Vue.use(VueRouter as any); // eslint-disable-line @typescript-eslint/no-explicit-any

let intendedUrl: string | null = null;

// call this in the *component* code (not here in the router setup)
export function beforeRouteLeave(to: Route, from: Route,  next: (to?: string | void | false) => void) {
    if(dirtyness.isDirty && !confirm("Changes may not be saved.  Click cancel to stay on this page.")) {
        return next(false);
    }
    else {
        dirtyness.reset();
        return next();
    }
}

const beforeEnterGuard: NavigationGuard = async (to: Route, from: Route, next: (to?: string | void) => void) => {

    //console.log(`### nav guard... signed in=${store.getters.isSignedIn} intendedUrl=${intendedUrl}`);

    if (store.getters.isSignedIn) {
        if (intendedUrl) {
            const url = intendedUrl;
            intendedUrl = null;
            console.log("### nav guard - now logged in - redirect");
            return next(url); // goto stored url
        } else {
            console.log("### nav guard - carry on...");
            return next(); // all is fine
        }
    }
    
    try {
        // get user from session storage
        await store.dispatch("loadSignedInUser");
    } catch (e) {
        console.log("@@@ loadSignedInUser failed ");
        console.error(e);
    } 
    
    if (store.getters.isSignedIn) {
        console.log("### nav guard - got login ok");
        next();
    } else {
        intendedUrl = to.path; // store entry url before redirect
        console.log("### nav guard - redirect to signin");
        next("/signIn");
    }
};

//
// -- set up the routes
//

const routes: Array<RouteConfig> = [];

routes.push({ path: "/",                   name: "HomeSignIn",    meta: { layout: "blank" },                                     component: () => import("../views/HomeSignIn.vue") });
routes.push({ path: "/signin",             name: "SignIn",        meta: { layout: "signed-out" },                                component: () => import("../views/SignIn.vue") });
routes.push({ path: "/resetPassword/:key", name: "ResetPassword", meta: { layout: "signed-out" },                                component: () => import("../views/ResetPassword.vue") });
routes.push({ path: "/Error",              name: "Error500",      meta: { layout: "signed-out" },                                component: () => import("../views/Error500.vue") });

routes.push({ path: "/Home",               name: "Home",          meta: { layout: "signed-in" },  beforeEnter: beforeEnterGuard, component: () => import("../views/Home.vue") });
routes.push({ path: "/Profile", name: "Profile", meta: { layout: "signed-in" }, beforeEnter: beforeEnterGuard, component: () => import("../views/Profile.vue") });
routes.push({ path: "/Employees", name: "Employees", meta: { layout: "signed-in" }, beforeEnter: beforeEnterGuard, component: () => import("../views/Employees.vue") });
routes.push({ path: "/Bookings", name: "Bookings", meta: { layout: "signed-in" }, beforeEnter: beforeEnterGuard, component: () => import("../views/Bookings.vue") });
routes.push({ path: "/BookingsManager", name: "BookingsManager", meta: { layout: "signed-in" }, beforeEnter: beforeEnterGuard, component: () => import("../views/BookingsManager.vue") });
routes.push({ path: "/TermsAndConditions", name: "TermsAndConditions", meta: { layout: "signed-in" }, beforeEnter: beforeEnterGuard, component: () => import("../views/TermsAndConditions.vue") });
routes.push({ path: "/About", name: "About", meta: { layout: "signed-in" }, beforeEnter: beforeEnterGuard, component: () => import("../views/About.vue") });

routes.push({ path: "/users",              name: "Users",         meta: { layout: "signed-in" },  beforeEnter: beforeEnterGuard, component: () => import("../views/Users.vue") });
routes.push({ path: "/lookups/:groupID",   name: "Lookups",       meta: { layout: "signed-in" },  beforeEnter: beforeEnterGuard, component: () => import("../views/Lookups.vue") });

// This needs to be the **last** routes
routes.push({ path: "*",                                          meta: { layout: "signed-out" },                                component: () => import("../views/Error404.vue") });

//
// -- create the router
//

const router = new VueRouter({
    mode: "history",
    linkActiveClass: "active",
    linkExactActiveClass: "active",
    base: process.env.BASE_URL,
    routes
});

export function goToIntendedUrl() {
    if (!intendedUrl) router.replace("/Bookings/"); // default in case not defined (?)
    router.replace(intendedUrl as RawLocation);
}

export default router;
